import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {NgModule, ErrorHandler} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {InbeCommonsModule} from '@app/components/_common/inbe-commons.module';
import {MediaModule} from '@app/components/_common/medias/media.module';
import {ExtProfilsEffects} from '@app/components/projects/ext-profils/store/ext-profils.effects';
import {AnnotationEffects} from '@app/components/projects/surveys/annotation/store/annotation.effects';
import {PublicationsEffect} from '@app/components/publications/store/publications/publications.effects';
import {AuthEffects, clearState} from '@app/store/effects/auth.effects';
import {ProjectEffects} from '@app/store/effects/project.effects';
import {TranslatePoHttpLoader} from '../@fjnr/translate-po-http-loader';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from '@fuse/components';
import {FuseWidgetModule} from '@fuse/components/widget/widget.module';
import {FuseModule} from '@fuse/fuse.module';
import {FuseSharedModule} from '@fuse/shared.module';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {reducers} from '@store/app.states';
import {ActivePublicationEffects} from '@app/components/publications/create-publication/_store/active-publication.effects';
import {SplitterModule} from '@syncfusion/ej2-angular-layouts';
import {LaddaModule} from 'angular2-ladda';
import {DxChartModule, DxDataGridModule, DxPieChartModule, DxPopupModule, DxProgressBarModule, DxSliderModule, DxSparklineModule} from 'devextreme-angular';
import {ToastrModule} from 'ngx-toastr';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {fuseConfig} from './components-fuse/fuse-config';
import {LayoutModule} from './components-fuse/layout/layout.module';
import {StatusComponent} from './components/_common/status/status.component';
import {AuthGuardService as AuthGuard} from './services/auth/auth-guard.service';
import {AuthService} from './services/auth/auth.service';
import {ErrorInterceptor, TokenInterceptor} from './services/token.interceptor';
import {AnnotatorsEffects} from '@app/components/projects/surveys/annotation/store/annotators.effects';
import {ApplicationPipesModule} from '../application-pipes/application-pipes.module';
import {DeactivateGuard} from '@app/components/_common/deactivate-guard.service';
import {PublicationSideBarModule} from './components/publications/publication-sideBar/publication-side-bar.module';
import {Adm1nModule} from '@app/4dm1n/Adm1n.module';
import {NgResizeObserverPonyfillModule} from 'ng-resize-observer';
import {MetaSurveysEffects} from '@app/services/metas/store/meta-surveys.effects';
import {FirebaseStatusEffects} from '@app/firebase-status/firebase-status.effects';
import {FirebaseStatusModule} from '@app/firebase-status/firebase-status.module';
import {Login2Module} from '@app/components/login/login-2.module';
import {GenericListModule} from '../@shared/_generalTools/generic-list/generic-list.module';
import {LoadingDirectiveModule} from '../@shared/loading-directive/loading-directive.module';
import {JsonEditorComponent} from '../@shared/_generalTools/json-editor/json-editor.component';
import {BtnDisplayDashboardForSurveyComponent} from '../@shared/surveys-selector/btn-display-dashboard-for-survey/btn-display-dashboard-for-survey.component';
import {KeyboardShortcutsModule} from 'ng-keyboard-shortcuts';
import {WorkerIndicatorComponent} from '@app/4dm1n/works-dashboard/worker-indicator/worker-indicator.component';
import {HideTopBarComponent} from '@app/components-fuse/layout/components/hide-top-bar/hide-top-bar.component';
import {DashboardQualityPopUpServiceService} from '@app/components/projects/surveys/results/dashboardQuality/dashboard-quality-pop-up-service.service';
import {MailElasticStatComponent} from '@app/components/projects/eMailCampaigns/e-mails-batch-list/mail-elastic-stat/mail-elastic-stat.component';
import {MaterialModule} from '../@material';
import {TestFlagsComponent} from '../@shared/test-flags/test-flags.component';
import { MatDialogModule } from '@angular/material/dialog';

import Bugsnag from '@bugsnag/js';
// import {BugsnagErrorHandler} from '@bugsnag/plugin-angular/dist/esm5';
import {environment} from '@environments/environment';
import {BugsnagErrorHandler} from '@bugsnag/plugin-angular';

//
// Bugsnag stuff ----------------------------------------------------------------------------------*
//
Bugsnag.start(
  {
    apiKey: '9ea8efe6d8c278622db9ba7a0ff7eb67',
    enabledReleaseStages: ['production', 'staging'],
    releaseStage: environment?.production ? 'production' : 'approbation',
    onError: (event) => {
      const file: string = event?.errors?.[0]?.stacktrace?.[0]?.file;
      if (file.includes('node_modules') || file.includes('vendor')) {
        console.log('[BugSnagOnError] ------------->', event?.errors?.[0]?.stacktrace?.[0]?.file);
        return false;
      }
      return true;
    }
  }
);

export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

export class AppErrorHandler implements ErrorHandler {
  handleError(error: any) {
    Bugsnag.notify(error);
    console.error(error);
  }
}

//
// -------------------------------------------------------------------------------------------------*
//


export function createTranslateLoader(http: HttpClient) {
  return new TranslatePoHttpLoader(http, 'assets/i18n', '.po');
}


@NgModule({
  declarations: [
    AppComponent,
    StatusComponent,
    // EMailsCampaignsListComponent,
  ],
  imports: [
    BrowserModule,
    FirebaseStatusModule,
    BrowserAnimationsModule,
    ApplicationPipesModule,

    ToastrModule.forRoot({
      preventDuplicates: true,
      countDuplicates: true,
    }),

    HttpClientModule,

    AppRoutingModule,

    InbeCommonsModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),

    //
    MediaModule,
    MaterialModule,

    LaddaModule.forRoot({
      style: 'slide-left',
      // spinnerSize: 40,
      // spinnerColor: 'red',
      // spinnerLines: 12
    }),
    // LaddaModule.forRoot({
    //   // style: "contract",
    //   // spinnerSize: 40,
    //   // spinnerColor: "red",
    //   // spinnerLines: 12
    // }),
    // Fuse modules
    FuseModule.forRoot(fuseConfig),
    FuseProgressBarModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,
    // FuseNavigationModule,
    LayoutModule,
    FuseWidgetModule,
    SplitterModule,
    FormsModule,
    ReactiveFormsModule,
    EffectsModule.forRoot([
      //
      AuthEffects,
      MetaSurveysEffects,
      //
      // todo: EC
      // Il faudrait déplacer l'effet de chargement des publications dans un autre effet...
      PublicationsEffect,
      ProjectEffects,
      ExtProfilsEffects,
      // EMailCampaignEffects,
      // EmailUserSelectorEffects,
      // EMailTemplatesEffects,
      // PreviewCampaignEffects,
      ActivePublicationEffects,
      AnnotatorsEffects,
      // ?
      // SurveyDetailedResponsesEffects,
      // DashboardResultsEffectEffects,

      // ?
      // FilterPanelEffects,
      //
      //
      FirebaseStatusEffects,
      //
      AnnotationEffects,
    ]),
    StoreModule.forRoot(reducers, {
      metaReducers: [clearState],
      runtimeChecks: {
        //
        // Gridster fait chier...
        //
        strictStateImmutability: true,
        strictActionImmutability: true,
        //
        //
      },
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 50,
    }),

    DxDataGridModule,
    DxSliderModule,
    DxPieChartModule,
    //
    // App Modules
    //
    // ExtProfilsModule,
    NgResizeObserverPonyfillModule,
    PublicationSideBarModule,
    Adm1nModule,
    // PublicationsListModule,
    Login2Module,
    GenericListModule,

    DxSparklineModule,
    DxChartModule,
    DxProgressBarModule,
    DxPopupModule,
    LoadingDirectiveModule,
    JsonEditorComponent,
    BtnDisplayDashboardForSurveyComponent,
    KeyboardShortcutsModule,
    WorkerIndicatorComponent,
    HideTopBarComponent,
    MailElasticStatComponent,
    TestFlagsComponent,
    MatDialogModule,
  ],
  providers: [
    ApplicationPipesModule,
    AuthService,
    AuthGuard,
    DeactivateGuard,
    {
      provide: ErrorHandler,
      // useClass: AppErrorHandler
      useFactory: errorHandlerFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    DashboardQualityPopUpServiceService,
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}

